import { render, staticRenderFns } from "./ProjectTaskTemplateEdit.vue?vue&type=template&id=59a7a9ab"
import script from "./ProjectTaskTemplateEdit.vue?vue&type=script&lang=js"
export * from "./ProjectTaskTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports